import { AuthError, sendEmailVerification, User } from "firebase/auth";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

const EmailVerificationPrompt: React.FC<{ user: User }> = ({ user }) => {
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSendVerification = async () => {
        setIsLoading(true);
        setMessage(null);
        setError(null);
        try {
            await sendEmailVerification(user);
            setMessage(
                "Verification email sent! Please check your inbox (and spam folder) and click the link."
            );
        } catch (err: any) {
            setError(
                (err as AuthError).message || "Failed to send verification email."
            );
            console.error("Error sending verification email:", err);

            const friendly = getFriendlyFirebaseError(err.code);
            toast.error(friendly);
        } finally {
            setIsLoading(false);
        }
    };

    const getFriendlyFirebaseError = (code: string) => {
        switch (code) {
            case "auth/too-many-requests":
            case "auth/too-many-attempts-try-later":
                return "Too many attempts. Please try again later.";
            case "auth/user-not-found":
                return "User not found.";
            case "auth/invalid-email":
                return "Invalid email address.";
            default:
                return "Something went wrong. Please try again.";
        }
    };


    return (
        // <>
        //     <div className="verify_email">
        //         <div className="top top_bar_flx border_tittle">
        //             <div className="top_bar_tittle">
        //                 <h2>Verify Email</h2>
        //             </div>
        //             <div className="top_right_flx">
        //                 <Button onClick={handleSendVerification} disabled={isLoading} className="btn_sm">
        //                     {isLoading ? "Sending..." : "Send Verification Email"}
        //                 </Button>
        //             </div>
        //         </div>
        //         <div className="stats">
        //             <h3>Your email address is not verified. Please verify to enable all features.</h3>
        //             {message && <p>{message}</p>}
        //             {error && <p>Error: {error}</p>}
        //             <p>After verifying, you might need to refresh this page or log out and log back in.</p>
        //         </div>
        //     </div>
        // </>
        <>
            <div className="w-full bg-white border border-[#E2E8F0] rounded-xl p-[20px] mt-4">
                {/* Top Bar */}
                <div style={{ marginBottom: "20px", borderBottom: "1px solid #E5E5E5", paddingBottom: "10px" }} className="flex justify-between flex-wrap w-full">
                    <h2 className='text-[#1D1D1F] text-[18px] 2xl:text-[22px] font-[500]'>Verify Email</h2>

                </div>

                {/* Content */}
                <div className="w-full flex justify-between gap-2">
                    <div className="flex flex-col gap-2 w-[70%]">
                        <h3 className="text-sm font-medium text-[#1A202C]">
                            Your email address is not verified. Please verify to enable all features.
                        </h3>

                        {message && (
                            <p className="text-sm text-green-600">
                                {message}
                            </p>
                        )}

                        {error && (
                            <p className="text-sm text-red-600">
                                Error: {error}
                            </p>
                        )}

                        <p className="text-sm text-[#718096]">
                            After verifying, you might need to refresh this page or log out and log back in.
                        </p>
                    </div>
                    <div className="w-[30%] flex justify-end ">
                        <button
                            onClick={handleSendVerification}
                            disabled={isLoading}
                            className="bg-[#7E57C2] hover:bg-[#6b4db5] transition text-white text-sm font-medium px-3 py-2 rounded-lg disabled:opacity-60 disabled:cursor-not-allowed h-fit whitespace-nowrap"
                        >
                            {isLoading ? "Sending..." : "Send Verification Email"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};


export default EmailVerificationPrompt;